import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { DarkVeil } from '../components';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.sendForgotPasswordEmail(email);
            setSent(true);
            toast.success(t('forgot.toastSuccess') || 'Email sent successfully!');
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            toast.error(t('forgot.toastError') || 'Failed to send email');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="new-login-page">
            <div className="new-login-container">
                <div className="new-login-left">
                    <div className="new-login-left-animation">
                        <DarkVeil
                            colors={["#008cffff", "#9b00afff", "#00ffb3ff"]}
                            rotation={0}
                            speed={0.2}
                            scale={1}
                            frequency={1}
                            warpStrength={1}
                            mouseInfluence={1}
                            parallax={0.5}
                            noise={0.1}
                            transparent
                            autoRotate={0}
                        />
                    </div>
                    <div className="new-login-left-content">
                        <h2 className="new-login-left-title">
                            {t('forgot.newLeftTitle') || t('forgot.leftTitle')}
                        </h2>
                        <p className="new-login-left-subtitle">
                            {t('forgot.newLeftSubtitle') || t('forgot.subtitle')}
                        </p>
                        <div className="new-login-social">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                                <FaFacebook size={20} />
                                Facebook
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                <FaInstagram size={20} />
                                Instagram
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin size={20} />
                                LinkedIn
                            </a>
                        </div>
                    </div>
                </div>
                <div className="new-login-right">
                    <div className="new-login-form-container">
                        <div className="new-login-logo">
                            <img 
                                src="/assets/images/nordex_login_image.png" 
                                alt="Nordex Forgot Password" 
                                className="login-brand-image"
                            />
                        </div>
                        <form className="new-login-form" onSubmit={onSubmit}>
                            <div className="new-login-input-group">
                                <label htmlFor="email">{t('forgot.emailLabel')}</label>
                                <input
                                    id="email"
                                    type="email"
                                    placeholder={t('forgot.emailPlaceholder')}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value.replace(/\s/g, ''))}
                                    onKeyDown={(e) => {
                                        if (e.key === ' ') {
                                            e.preventDefault();
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="new-login-submit-btn"
                                disabled={loading || !email}
                            >
                                {loading ? t('forgot.submitting') : sent ? t('forgot.sent') : t('forgot.submit')}
                            </button>
                            <div className="new-login-forgot">
                                <Link to="/login">
                                    {t('forgot.backToLogin')}
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Toaster
                position="top-center"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    success: {
                        duration: 3000,
                        style: {
                            background: '#10B981',
                            color: '#fff',
                        },
                    },
                    error: {
                        duration: 5000,
                        style: {
                            background: '#EF4444',
                            color: '#fff',
                        },
                    },
                }}
            />
        </div>
    );
}
